import * as React from 'react'

export const Placeholder = () => (
    <div id="pv-nav-main-menu" className="pv-nav-main-menu"></div>
)
